import { computed, inject, Injectable, signal, Signal } from '@angular/core';

import { AuthSelectorsService, KrosAuthService } from '@kros-sk/auth';

/**
 * Runs the viewer's silent-SSO probe and reports when the login state is final.
 */
@Injectable({ providedIn: 'root' })
export class AuthProbeService {
  readonly #authService = inject(KrosAuthService);
  readonly #authSelectors = inject(AuthSelectorsService);

  readonly #probed = signal(false);
  readonly #foundSession = signal(false);

  readonly settled: Signal<boolean> = computed(
    () => this.#probed() && (!this.#foundSession() || this.#authSelectors.isLoggedIn()),
  );

  run(): void {
    void this.#authService.trySilentLogin().then(
      (foundSession) => this.#finish(foundSession),
      () => this.#finish(false),
    );
  }

  #finish(foundSession: boolean): void {
    this.#foundSession.set(foundSession);
    this.#probed.set(true);
  }
}
